import { useState } from "react";
import MainFiltersItemScrollable from "./MainFiltersItemScrollable";
import { useSoundPath } from "hooks/useSoundPath";


const MainFiltersItem = ({
  parentSwiper,
  category,
  filters,
  activeFilter,
  setActiveFilter,
  queryValue,
  searchParams,
  handleCheckboxChange,
  clearQueryParams,
}) => {


  const [isFilters, setIsFilters] = useState(false);

  const playSound = useSoundPath();

  const showFilter = (e) => {
    e.preventDefault();
    setIsFilters((prevIsFilters) => {
      const newIsFilters = !prevIsFilters;

      if (newIsFilters) {
          playSound('openSubmenu');
      } else {
          playSound('closeSubmenu');
      }

      return newIsFilters;
  });
    setActiveFilter(category);
  };



  return (
    <div className="main-content__filters-item">
      <button
        type='button'
        className={`main-content__filters-open ${isFilters && activeFilter === category ? 'active' : ''}`}
        onClick={showFilter}
      >
        {category}
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.66699 6.5L8.00031 11.8333L13.3337 6.5" stroke="#696F70" strokeWidth="1.5"></path>
        </svg>
      </button>
      <MainFiltersItemScrollable
        parentSwiper={parentSwiper}
        category={category}
        filters={filters}
        queryValue={queryValue}
        searchParams={searchParams}
        handleCheckboxChange={handleCheckboxChange}
        clearQueryParams={clearQueryParams}
      />
    </div>
  );
};

export default MainFiltersItem;

